import { render } from "./LicenseOldAndNewMain.vue?vue&type=template&id=6ccdcd99&scoped=true"
import script from "./LicenseOldAndNewMain.vue?vue&type=script&lang=js"
export * from "./LicenseOldAndNewMain.vue?vue&type=script&lang=js"

import "./LicenseOldAndNewMain.vue?vue&type=style&index=0&id=6ccdcd99&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ccdcd99"]])

export default __exports__